/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/*  
    Product Accordion module. 
    This module reloads product tabs when user makes selections.
*/

define('modules/Product/ProductAccordion',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var productLandingPageUrl;

    function reloadProductAccordion(viewModel) {
        Roc.Data.getAsync({
            url: productLandingPageUrl,
            data: { id: viewModel.id },
            callback: function (data) {
                if (data && data.Success === true) {
                    var content = $(data.html).filter('.accordionModule').html();

                    $('.accordionModule').html(content);
                }
            }
        });
    }

    function init(landingPageUrl) {
        productLandingPageUrl = landingPageUrl;
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductAccordion);

    }

    var ProductAccordion = {
        init: init
    }

    Roc.Logger.debug('ProductAccordion.js Loaded:', ProductAccordion);

    return ProductAccordion;
});
